import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ScriptLoaderService {
  private readonly loading = new Map<string, Promise<void>>();

  load(src: string): Promise<void> {
    if (this.loading.has(src)) {
      return this.loading.get(src)!;
    }

    const promise = new Promise<void>((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;

      script.onload = () => resolve();
      script.onerror = () => reject(new Error(`Failed to load ${src}`));

      document.head.appendChild(script);
    });

    this.loading.set(src, promise);
    return promise;
  }
}
